import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ClientApiModule from "../components/ClientApi/api";
import PublicTicketBookingClientQr from "./PublicTicketBookingClientQr";
import PublicTicketBookingQr from "./publicTicketBookingQr";

const BookingWrapper = () => {
  const { id } = useParams();
  const [isClientQR, setIsClientQR] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkQRType = async () => {
      try {
        const res = await new ClientApiModule().getClientByQrId({ qr_id: id });
        if (res.data && res.data.doesCenterExists) {
          setIsClientQR(true);
        } else {
          setIsClientQR(false);
        }
      } catch (error) {
        setIsClientQR(false);
      } finally {
        setLoading(false);
      }
    };

    checkQRType();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return isClientQR ? (
    <PublicTicketBookingClientQr />
  ) : (
    <PublicTicketBookingQr />
  );
};

export default BookingWrapper;
